import { useEffect, useState } from "react";
import useCookie from "./useCookie";

export default function useDetectIsInvited() {
  const [isInvited, setIsInvited] = useState(false);
  const { getCookie } = useCookie();

  const detectIsInvited = () => {
    const isInvited = getCookie("isInvited");
    if (!isInvited) return;
    setIsInvited(true);
  };

  useEffect(() => {
    detectIsInvited();
  }, []);

  return isInvited;
}
